// Client env evaluated once at module scope. Import `clientEnv` from here
// instead of calling unsafeLoadClientEnv() per module.
import { unsafeLoadClientEnv } from '@listening/env/config-keys';

export const clientEnv = unsafeLoadClientEnv();

// Vite compile-time constants — not config keys, can't be read with Config.String()
/* oxlint-disable env-access/no-raw-env-access -- Vite build-time constants */
export const isSSR = import.meta.env?.SSR ?? false;
export const isDev = import.meta.env?.DEV ?? false;
/* oxlint-enable env-access/no-raw-env-access */
